const useSetBookmark = () => {
  const handleBookMark = (
    bookmarks: IGetPostDetail[],
    post: IGetPostDetail,
    setBookmarks,
  ) => {
    if (bookmarks.length > 0) {
      if (bookmarks?.find(x => x?.guid === post?.guid)) {
        setBookmarks(bookmarks?.filter(x => x.guid !== post?.guid));
      } else {
        setBookmarks([...bookmarks, post]);
      }
    } else {
      setBookmarks([post]);
    }
  };
  return {handleBookMark};
};

export default useSetBookmark;
